import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { TYPES } from "@/lib/fieldCodec";

export function TypeSelect({ value, onChange, testId }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="h-8 w-28 text-xs font-mono" data-testid={testId}><SelectValue /></SelectTrigger>
      <SelectContent>{TYPES.map((t) => <SelectItem key={t} value={t} className="text-xs font-mono">{t}</SelectItem>)}</SelectContent>
    </Select>
  );
}

// Type-aware input for one field draft.
export function ValueInput({ type, draft, setDraft, testId }) {
  if (type === "boolean") return <Switch checked={!!draft} onCheckedChange={setDraft} data-testid={testId} />;
  if (type === "null") return <span className="text-xs font-mono text-muted-foreground">null</span>;
  if (type === "number") return <Input type="number" step="any" value={draft} onChange={(e) => setDraft(e.target.value)} className="h-8 font-mono text-sm" data-testid={testId} />;
  if (type === "timestamp") return <Input type="datetime-local" step="1" value={draft} onChange={(e) => setDraft(e.target.value)} className="h-8 font-mono text-sm" data-testid={testId} />;
  const json = ["map", "array"].includes(type);
  return (
    <Textarea value={draft} onChange={(e) => setDraft(e.target.value)} rows={json ? Math.min(14, String(draft).split("\n").length + 1) : 2}
      className="font-mono text-xs" spellCheck={false} data-testid={testId} />
  );
}
